import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Upload } from "antd";
import { CloudUploadOutlined, FileOutlined } from "@ant-design/icons";
//Utils
import { ERROR, REQUERIDO } from "../../../utils";
import { openNotification, validaArchivosPDF } from "../../../utils";
//Ducks
import { getUrlUpload } from "../../../redux/aspirante/catalogoDucks";

//props del upload
const files = {
  multiple: false,
  showUploadList: {
    showDownloadIcon: false,
    showRemoveIcon: false,
    removeIcon: false,
    showPreviewIcon: false,
  },
  //Valida el archivo antes de cargarlo
  beforeUpload: (file) => {
    if (!validaArchivosPDF(file)) {
      return Upload.LIST_IGNORE;
    }
  },
};

/**
 * Componente que muestra la carga del archivo para el formulario del requisito académico
 * Permite llevar el control de los archivos a subir (titulo o cédula).
 * @param {boolean} isRequired Si el campo de subir archivo es requerido o no.
 * @return {JSX.Element}
 */
export const ReqArchivo = ({ isRequired }) => {
  const dispatch = useDispatch();
  const [showFile, setShowFile] = useState(false);
  const [urlUpload, setUrlUpload] = useState("");
  //State-redux
  const { isReqAcademico } = useSelector((state) => state.reqAcademico);
  const { idEscolaridad: id, nombreArchivoOriginal: archivo } = isReqAcademico;

  useEffect(() => {
    dispatch(getUrlUpload()).then((data) => {
      setUrlUpload(data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //useEffect que valida si es un nuevo registro o es para modificar
  useEffect(() => {
    if (id && archivo) {
      setShowFile(true);
    } else {
      setShowFile(false);
    }
  }, [id, archivo]);

  //Al desmontar el componente se limpia el upload
  useEffect(() => {
    return () => {
      setShowFile(false);
    };
  }, []);

  /**
   * Función para cargar el archivo
   * @param {File} info
   */
  const handleChange = (info) => {
    const { status } = info.file;
    if (status !== "uploading") {
      // console.log(info.file, info.fileList);
    }
    if (status === "done") {
      id && setShowFile(false);
      // console.log(`${info.file.name} file uploaded successfully.`);
    } else if (status === "error") {
      const mensaje = "Al adjuntar el archivo, favor de volver a intentar.";
      openNotification("error", ERROR, mensaje);
    }
  };

  return (
    <>
      {showFile && (
        <div className="div-archivo caja-upload ">
          <div style={{ marginTop: 20 }}>
            <center>
              <FileOutlined style={{ fontSize: "30px", color: "#36a3ce" }} />
              <p style={{ marginTop: 5 }}>{archivo}</p>
            </center>
          </div>
        </div>
      )}
      <Form.Item name="archivo" valuePropName rules={REQUERIDO}>
        <Upload
          {...files}
          className="avatar-uploader"
          action={urlUpload}
          listType="picture-card"
          onChange={handleChange}
          maxCount={1}
          accept=".pdf,.PDF"
        >
          <UploadButton />
        </Upload>
      </Form.Item>
      <div style={{ fontSize: 12, fontWeight: 600 }}>
        <center>El sistema solo admite archivos en .pdf Máx. 5MB.</center>
      </div>
    </>
  );
};

const UploadButton = () => (
  <>
    <div>
      <div>
        <CloudUploadOutlined style={{ fontSize: "100px", color: "#dfdfe7" }} />
      </div>
      <div style={{ marginTop: 0 }}>
        Arrastra y suelta tu archivo aquí
        <p>o </p>
        <p
          style={{
            textDecoration: "underline",
            color: "#e32490",
            marginBottom: 20,
          }}
        >
          Selecciona el archivo{" "}
        </p>
      </div>
    </div>
  </>
);

// const InfoText = () => (
//   <div>
//     Sólo para el caso del Certificado de bachillerato no se considera
//     obligatorio para quienes concursan por un cargo ejecutivo.{""}
//     <QuestionCircleFilled style={{ color: "#e32490" }} />
//   </div>
// );
